import { Building2Icon, NetworkIcon } from 'assets/icons';
import { HardHat, Mail, User, UserRound } from 'lucide-react';

// A lucide icon with the `{ wh, color }` props of assets/icons.
const sized = (Icon) => {
  const SizedIcon = ({ wh, color }) => (
    <Icon size={wh} color={color} aria-hidden="true" />
  );
  return SizedIcon;
};

// The icon of each kind of record a task is linked to (helper/taskLinks).
const LINK_ICONS = {
  company: Building2Icon,
  group: NetworkIcon,
  contact: sized(User),
  tempWorker: sized(HardHat),
  // « Avec qui ? » of an appointment (components/planning/withWhom).
  colleague: sized(UserRound),
  email: sized(Mail),
};

export default LINK_ICONS;
